import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    constructor() {
    }

    /**
     * Retire un paramètre de la query string sans renavigation ni rechargement.
     * À appeler APRÈS le traitement du paramètre (event envoyé, popup ouverte), jamais avant :
     * un rafraîchissement ou un retour arrière ne doit pas rejouer ce traitement.
     */
    clearQueryParam(name: string) {
        const url = new URL(window.location.href);
        if (!url.searchParams.has(name)) {
            return;
        }
        url.searchParams.delete(name);
        const query = url.searchParams.toString();
        window.history.replaceState(window.history.state, '', url.pathname + (query ? '?' + query : '') + url.hash);
    }

    /**
     * Retour vers une liste avec une ancre (#ad_..., #fav_...) : re-scrolle jusqu'à la carte
     * dès qu'elle est rendue (réessaie pendant le chargement, 16s max).
     * Le scroll natif du navigateur ne suffit pas : la cible n'existe pas encore au chargement.
     */
    scrollToHashCard() {
        const hash = window.location.hash;
        if (!hash || hash.length < 2) {
            return;
        }
        const targetId = hash.substring(1);
        let tries = 0;
        let stable = 0;
        let lastTop = null;
        // Le premier geste de l'utilisateur (molette, tactile, clavier) rend la main :
        // on ne lui vole plus le scroll pendant la phase de recalage
        const cancel = () => stop();
        const stop = () => {
            clearInterval(timer);
            ['wheel', 'touchstart', 'keydown'].forEach(t => window.removeEventListener(t, cancel));
        };
        ['wheel', 'touchstart', 'keydown'].forEach(t => window.addEventListener(t, cancel, {passive: true}));
        const timer = setInterval(() => {
            tries++;
            const target = document.getElementById(targetId);
            if (target) {
                const r = target.getBoundingClientRect();
                const centered = Math.abs(r.top + r.height / 2 - window.innerHeight / 2) < 150;
                // Une carte en bas de page ne peut jamais être centrée : si sa position
                // ne bouge plus, le recalage est terminé même sans être centré
                const immobile = lastTop !== null && Math.abs(r.top - lastTop) < 2;
                lastTop = r.top;
                if (centered || immobile) {
                    // Le contenu qui finit de charger (images...) peut repousser la carte :
                    // on ne s'arrête qu'une fois la position stable sur plusieurs ticks
                    stable++;
                    if (stable >= 3) {
                        stop();
                        return;
                    }
                } else {
                    stable = 0;
                    // 'instant' : ignore le scroll-behavior: smooth global (l'animation peut être
                    // interrompue par les re-rendus du chargement)
                    target.scrollIntoView({block: 'center', behavior: 'instant'} as any);
                }
            }
            if (tries > 40) {
                stop();
            }
        }, 400);
    }

    compare(v1: number, v2: number, tolerance: number): number {
        if (v1 <= v2 * (1 + tolerance / 100) && v1 >= v2 * (1 - tolerance / 100)) {
            return 0;
        } else if (v1 > v2) {
            return 1;
        } else if (v1 < v2) {
            return -1;
        }
        return 0;
    }


    /** Prix compact pour les chips de filtres : 850k€, 1.2M€ */
    formatPrice(value: number): string {
        if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + 'M€';
        }
        if (value >= 1000) {
            return Math.round(value / 1000) + 'k€';
        }
        return value + '€';
    }

    percentLabel(value: number) {
        return value + '%';
    }

    euroLabel(value: number) {
        return value + '€';
    }

    zipcodeLabel(value) {
        if (value === null) {
            return '';
        }
        if (typeof value === 'string') {
            return value;
        }
        return value.zip_code;
    }

    cityLabel(value) {
        if (value === null) {
            return '';
        }
        if (typeof value === 'string') {
            return value;
        }
        return value.name;
    }

    round(n) {
        if (isNaN(n)) {
            return 0;
        }
        if (n === Math.round(n)) {
            return Math.round(n);
        }
        return n.toFixed(1);
    }

    formatDate(date: Date) {
        return (date.getDate() <= 9 ? '0' : '') + date.getDate() + '/' + (date.getMonth() + 1 <= 9 ? '0' : '') + (date.getMonth() + 1) + '/' + date.getFullYear();
    }

    getStatusLib(key) {
        switch (key) {
            case 'analyse' :
                return 'Analyse en cours';
                break;
            case  'contact':
                return 'À contacter';
                break;
            case 'visite':
                return ' À visiter';
                break;
            case 'offre':
                return 'Offre à faire';
                break;
            case 'offre_ok':
                return 'Offre acceptée';
                break;
            case 'offre_ko':
                return 'Offre refusée';
                break;
            case 'sell' :
                return 'Déjà vendu';
                break;
            case 'abandon':
                return 'Pas intéressant';
                break;
            case 'offre_reponse':
                return 'En attente retour';
                break;
            case 'buy':
                return 'Propriétaire';
                break;
        }
    }
}
